import { render, staticRenderFns } from "./OvertimeCancelled.vue?vue&type=template&id=c5c60e74"
import script from "./OvertimeCancelled.vue?vue&type=script&lang=js"
export * from "./OvertimeCancelled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports